import { Component, Vue } from 'vue-property-decorator'

@Component
export class BaseComponent extends Vue {}

@Component
export class BasePage extends BaseComponent {}

export * from 'vue-property-decorator'
